















import { Component, Vue } from 'vue-property-decorator'
import Description from './description.vue'
import Description2 from './description2.vue'
import Deliver from '../deliver.vue'
import { ShopTypes } from '../../config'

import Time from './time.vue'
import Addreess from './address.vue'

import { namespace } from 'vuex-class'
const shopHomeModule = namespace('shopHome')

@Component({
  components: {
    Description,
    Description2,
    Time,
    Addreess,
    Deliver
  }
})
export default class Header extends Vue {
  @shopHomeModule.State shopDetail!: any
  @shopHomeModule.State shopType!: ShopTypes
  readonly Children: ShopTypes = ShopTypes.Children

  async created() {
    // this.getShopDetailAction(53623)
    // this.getShopDetailP()
    // this.getCategoryP()
    // this.getCommentP()
  }
}
